export default {
  NEW: 'new',
  NEW_ARRIVAL: 'newArrival'
};
